import type { Locale } from "@/i18n/locales";
import type { HotTopicLocalePack } from "./hot-cluster.i18n";
import type { HotCompareLocalePack } from "./hot-compare.i18n";
import type { HowItWorksTranslation } from "./how-it-works-content.i18n";

/**
 * Registry for translated SEO copy (HOT clusters, comparisons, How it works).
 *
 * These packs are ~500 KB of prose across seven languages. They used to be
 * statically imported by the route files, which put every language in the main
 * client bundle. They are now registered per locale: eagerly on the server (see
 * seo-content.server.ts) and as one chunk per language on the client (see
 * client.tsx), so a visitor only downloads the language they are reading.
 */
export type SeoContentPack = {
  hotTopics?: HotTopicLocalePack;
  hotCompare?: HotCompareLocalePack;
  howItWorks?: HowItWorksTranslation;
};

const PACKS: Partial<Record<Locale, SeoContentPack>> = {};

export function registerSeoContent(locale: Locale, pack: SeoContentPack | undefined) {
  if (!pack) return;
  PACKS[locale] = { ...PACKS[locale], ...pack };
}

export function seoPack(locale: Locale): SeoContentPack | undefined {
  return PACKS[locale];
}
